module.exports = __webpack_public_path__ + "img/deviceList_S.c434f3bf.png";